import { configureStore } from '@reduxjs/toolkit';
import setupIdling from './utils/application-idle';
import setupScheduleTick from './utils/schedule-tick';
import * as reducers from './modules';
import { setupAxiosRetryInterceptor } from '../utils/axios-retry';

const store = configureStore({
  reducer: {
    ...reducers,
    appTime: Date.now
  }
});

setupIdling(store);
setupScheduleTick(store);
setupAxiosRetryInterceptor();

export default store;
